<template>
    <!-- Link to course page with the course id. Pass the course object so the page can query it -->
    <div class="card" @click="routeToCourse">
        <div :style="headerStyle" class="card-header">
            <div class="course-details">
                <div class="course-overview">
                    <div>
                        <h4>{{ code }}</h4>
                    </div>
                    <div>
                        <h6>{{ credits }} credits</h6>
                    </div>
                </div>
                <div class="course-rating row">
                    <img src="@/assets/icons/other/star-gold.svg" id="star-icon" />
                    <h2>{{ roundedRating }}</h2>
                </div>
            </div>
            <div class="img-container">
                <img :src="iconURL" id="bgd-icon" />
            </div>
        </div>
        <div class="card-body">
            <h4>{{ title }}</h4>
            <p>Rated by {{ numReviews }} people who have taken the class in the past</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "CourseCard",
    // This is the "parameter" to this object, we treat it as data
    props: {
        id: String,
        code: String,
        credits: Number,
        rating: Number,
        title: String,
        numReviews: Number,
        color: String,
        courseIcon: String
    },

    computed: {
        headerStyle() {
            return "background-color: " + this.color;
        },

        iconURL() {
            return require("@/assets/icons/classes/" + this.courseIcon + "-icon.svg");
        },

        roundedRating() {
            return this.rating.toFixed(1);
        }
    },

    methods: {
        routeToCourse() {
            this.$router.push({ name: "course", params: { course: this.id } });
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/styles/_main.scss";

.card {
    background-color: $lighter;
    border-radius: 12px;
    cursor: pointer;
    min-height: 317px;
    height: 317px;
    min-width: 250px;
    max-width: 294px;
    overflow-y: hidden;
}

.card-body {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 50%;
    justify-content: space-between;
    text-decoration: none;
    padding: 20px;

    p {
        opacity: 0.4;
        margin: 0;
        font-size: 14px;
    }

    h4 {
        line-height: 28px;
        color: #656060;
    }
}

.card-header {
    background: url("../../assets/visuals/card-background.svg") repeat;
    border-radius: 12px 12px 0px 0px;
    height: 50%;

    .img-container {
        display: flex;
        justify-content: flex-end;
        margin-left: -15px;
        margin-top: -10px;
        width: 100%;
    }

    #bgd-icon {
        height: 75px;
    }

    #star-icon {
        height: 16px;
        width: 16px;
        align-self: center;
        padding: 0 10px;
    }
}

.course-details {
    display: flex;
    justify-content: space-between;
    padding: 20px;
}

.course-overview {
    &,
    h4,
    h6 {
        color: $white;
    }
}

.course-rating {
    align-items: flex-start;

    &,
    h2 {
        color: #f9db5f;
    }
}
</style>
